module.exports = __webpack_public_path__ + "static/media/emissor-r-5.e8e8508d.png";